import request from './request';

const userService = {
  getAll: (params) => request.get('dashboard/admin/users/paginate', { params }),
  /** Customers only (non-admin); paginated: data + pagination */
  listCustomers: (params) =>
    request.get('dashboard/admin/users/list', { params }),
  getUserDetails: (id, params) =>
    request.get(`dashboard/admin/users/${id}/details`, { params }),
  /** Customer dashboard: user, stats, orders, refunds, top products */
  getCustomerInsights: (id, params) =>
    request.get(`dashboard/admin/users/${id}/customer-insights`, { params }),
  /**
   * How the account was made, how it has behaved, where it signs in from.
   *
   * Separate call from customer-insights on purpose: that one is the commercial
   * view and loads with the page, this one is the diagnostic view and can reach
   * a geolocation provider. `refresh` looks the registration address up again.
   */
  getAnalytics: (id, { refresh = false } = {}) =>
    request.get(`dashboard/admin/users/${id}/analytics`, {
      params: refresh ? { refresh: 1 } : {},
    }),
  getById: (id, params) =>
    request.get(`dashboard/admin/users/${id}`, { params }),
  create: (data) => request.post('dashboard/admin/users', data),
  update: (id, data) => request.put(`dashboard/admin/users/${id}`, data),
  delete: (id) => request.delete(`dashboard/admin/users/${id}`),
  search: (params) => request.get(`dashboard/admin/users/search`, { params }),
  /** Role names for admin user tabs (id, name) */
  getRoles: (params) => request.get('dashboard/admin/roles', { params }),
  /** Set user role. Body: { roleNames: ["customer"] } or ["admin"] (global admin only for admin) */
  setUserRoles: (uuid, data) =>
    request.put(`dashboard/admin/users/${uuid}/roles`, data),
  /** Backfill customer role on legacy users (global admin only) */
  backfillCustomerRoles: () =>
    request.post('dashboard/admin/users/backfill-customer-roles'),
  updatePassword: (uuid, params) =>
    request.post(`dashboard/admin/users/${uuid}/password`, {}, { params }),
  setActive: (id, params) =>
    request.post(`dashboard/admin/users/${id}/active`, {}, { params }),
  createAddress: (uuid, data) =>
    request.post(`dashboard/admin/users/${uuid}/addresses`, data),
  topupWallet: (uuid, data) =>
    request.post(`dashboard/admin/users/${uuid}/wallets`, data),
  walletHistory: (uuid, params) =>
    request.get(`dashboard/admin/users/${uuid}/wallets/history`, { params }),
  profileShow: (params) =>
    request.get('dashboard/user/profile/show', { params }),
  profileUpdate: (data) => request.put('dashboard/user/profile/update', data),
  profileFirebaseToken: (data) =>
    request.post('dashboard/user/profile/firebase/token/update', data),
  dropAll: () => request.get(`dashboard/admin/users/drop/all`),
  restoreAll: () => request.get(`dashboard/admin/users/restore/all`),
  loginAs: (uuid) => request.get(`dashboard/admin/users/${uuid}/login-as`),
  addProductReview: (uuid, data) =>
    request.post(`dashboard/user/products/review/${uuid}`, data),
};

export default userService;
